export default class PrivacyForm {
    constructor() {
        this.consentCheckboxSelector = '.privacy-form-consent-checkbox';
        this.valueInputDataAttribute = 'value-input';
    }

    init() {
        this.handleCheckboxChange();
    }

    handleCheckboxChange() {
        $('body').on('change', this.consentCheckboxSelector, (e) => {
            const form = $(e.currentTarget).closest('form');
            const checkedIds = form.find(`${this.consentCheckboxSelector}:checked`)
                .map(function () {
                    return this.value;
                })
                .get()
                .join(';');
            form.find(`input[name="${$(e.currentTarget).data(this.valueInputDataAttribute)}"]`).val(checkedIds || '-');
        });
    }
}
